// extracted by mini-css-extract-plugin
export default {"root":"EmojiPicker_root__8JS4D","rootShow":"EmojiPicker_rootShow__CoB4B"};